export enum API_URL {
    generateToken = '/PlexNewAPI/api/Login/Authenticate/',
    generateKBHToken = '/kotakbh/login/generateToken/save',
    generateRefreshToken = '/kotakbh/login/generateRefreshToken',
    arnRemappingForEmpID = '/CrmMapping/api/Values/ARN_RMMapping/',
    crmMappingToken = '/CrmMapping/api/Login/Authenticate/',
    getUserDataFromARN = '/PlexNewAPI/api/Values/GetUserData',
    getTotalAumDataFromARN = '/PlexNewAPI/api/Values/GetAumData',
    sendOTP = '/kotakbh/login/sendOtp',
    validateOTP = '/kotakbh/login/validateSendOtp',
    biomatricToken = '/kotakbh/login/biomatricToken',
    // saveProfileInfo = '/kotakbh/distributor/profile/save',
    saveProfileInfo = '/kotakbh/admin/user/save1',
    updateProfileInfo = '/kotakbh/admin/updateuser1',
    // getProfileInfo = '/kotakbh/distributor/profile',
    getProfileInfo = '/kotakbh/admin/getUserdetailByArnNo',
    saveDeviceInfoForAuthType = '/kotakbh/device/details/save',
    saveNextValueInfo = '/kotakbh/goal/save',
    initiateTransaction = '',
    investorList = '/PlexNewAPI/api/Values/GetInvestorSearch_ByName_New',
    schemeList = '/PlexNewAPI/api/Values/GetNo_Schemes_With_Code/',
    investorFolioList = '/PlexNewAPI/api/one/FolioLevel_investor_registered',
    investorListingPage = '/PlexNewAPI/api/Values/GetClientCount_Total_CurrentFinYear/',
    schemeDetails = '/PlexNewAPI/api/Values/GetNo_Investors_With_SchemeCode/',
    sipReportList = '/PlexNewAPI/api/one/SIP_Registration_Report_Total',
    stpReportList = '/PlexNewAPI/api/one/STP_REGISTRATION_REPORT_Total',
    swpReportList = '/PlexNewAPI/api/one/SWP_REGISTRATION_REPORT_Total',
    //prostart
    prostartWelcomeList = '/kotakbh/video/getByFilterMainPage?bucketname=trending',
    prostartVideoList = '/kotakbh/video/getByFilter',
    prostartIncreaseWatchCount = '/kotakbh/video/increasewatchcount/',
    prostartIncreaseLikeCount = '/kotakbh/video/increaselike/',
    prostartGetAllSubBucket = '/kotakbh/sub-bucket/getbybucket/',
    prostartGetAllBucket = '/kotakbh/bucket/getbyvideo',
    prostartSubmitSuggetion = '/kotakbh/videofeedback/api/save',
    getClientIPAddress = 'https://api.ipify.org/?format=json',
    watchReport = '/kotakbh/watchedreport/api/save',
    prostartGetVideoById = '/kotakbh/video/api/getbyid/',
    // Transaction APIs
    //Api for Switch
    getRedeemScheme = '/KMFUnification/api/Admin/GETREDEEMSCHEME',
    validateBroker = '/INVESTOR/api/Admin/VALIDATEBROKER',
    euinDetails = '/KMFUnification/api/Admin/EUINDETAILS',
    folioValidation = '/KMFUnification/api/Admin/GETFOLIODETAILS',
    fundCategoryValidation = '/KMFUnification/api/Admin/GETSCHMAPTYPE',
    getFundCategoryList = '/KMFUnification/api/Admin/GETMAPSCHTYPE',
    getFundCategoryCode = '/KMFUnification/api/Admin/GETSCHEMENAMESTPCHECKED',
    getFundList = '/KMFUnification/api/Admin/GETSCHEMESTATUS',
    getSchemeOptions = '/KMFUnification/api/Admin/GETSCHEMENAME',
    getSTPAllowedDates = '/KMFUnification/api/Admin/GETSCHEMEDATEDETAILS',
    getSTPSchemeDetails = '/KMFUnification/api/Admin/GETSIPINSTALMENTSTPCHECKED',
    getDistributorCart = '',
    transactionDetails = '',
    getAdminSchemeDetails = '/KMFUnification/api/Admin/GETADMINSCHEMEDETAILS',
    getSchemeStatus = '/KMFUnification/api/Admin/GETSCHEMESTATUS',
    getReInvestmanetDetails = '/KMFUnification/api/Admin/GETREINVESTDETAILS',
    getBankDetails = '/KMFUnification/api/Admin/GETEXITBANKNAME',
    getSchemeDetails = '/KMFUnification/api/Admin/GETSCHEMEDETAILS',
    switchTransaction = '/KOTAKDISAPI/api/Switch/DistributorSwitchTrxDet',
    redeemTransaction = '/KOTAKDISAPI/api/Redeem/DistributorRedeemTrxDet',
    postLumpsumTransactionData = '/KOTAKDISAPI/api/Additionalpurchase/DistributorAPTrxDet',
    postSIPTransactionData = '/KOTAKDISAPI/api/SIP/DistributorSIPTrxDet',
    postSIPFirstTimeTransactionData = '/KOTAKDISAPI/api/StartSIP/DistributorStartSIPTrxDet',
    postZBFTransactionData = '/KOTAKDISAPI/api/Zerobalance/DistributorZerobalTrxDet',
    postSWPTransactionData = '/KOTAKDISAPI/api/SWP/DistributorSWPTrxDet',
    payoutBankDeatils = '/KMFUnification/api/Admin/GETPAYOUTBANKNAME',
    bankDetailsInfo = '/KMFUnification/api/Admin/GETPAYOUTBANKACCOUNTDETAILS',
    transactSTP = '/KOTAKDISAPI/api/STP/DistributorSTPTrxDet',
    getTranscationReference = '/kotakbh/trans/',
    updateTransactionReference = '/kotakbh/trans/update',
    saveTranscationReference = '/kotakbh/dit/save',
    saveAllTranscationReference = '/kotakbh/dit/saveAll',
    getSchemeDateDetails = '/KMFUnification/api/Admin/GETSCHEMEDATEDETAILS',
    getSipPuseDetails = '/KMFUnification/api/Admin/GETSIPPAUSETDETAILS',
    camsOTMDetails = '/KMFUnification/api/Admin/GETOTMDTLS',
    kotakOTMDetails = '/KMFUnification/api/Admin/GETOTMDETLIST',
    otmAccountDetails = '/KMFUnification/api/Admin/GETOTMACCDTLS',
    sipPauseTransaction = '/INVESTOR/api/Admin/GETSIPPAUSECONFIRM',
    transcationHistory = '/kotakbh/dit/',
    getPincodeDetails = '/KMFUnification/api/Admin/GETPINCODEDET',
    getPendingTransaction = '/kotakbh/trans/',
    deleteTransaction = '/kotakbh/trans/delete/',

    // Stop Transaction
    getTransactionBasedOnModeType = '/KMFUnification/api/Admin/GETMAPPEDSYSDETAILS',
    stopTransaction = '/KMFUnification/api/Admin/STOPTRANSACTIONDISTRIBUTOR', //'/cug/api/Admin/STOPTRANSACTIONDISTRIBUTORKBH',,
    // New investor
    getTaxStatus = '/KMFUnification/api/Admin/GETAXSTAUS',
    validatePANStatus = '/INVESTOR/api/Admin/VerifyPan',
    getNomineeRelations = '/KMFUnification/api/Admin/GETNOMINEERELDET',
    fatcaDetails = '/KMFUnification/api/Admin/FATCADETAILS',
    bankMasterDetails = '/KMFUnification/api/Admin/GETBANKMASTERLOAD',
    ifscSearchPAYMENT = '/INVESTOR/api/Admin/IFSCSEARCH',
    ifscSearch = '/KMFUnification/api/Admin/IFSCSEARCH',
    check_AdharSeeding = '/KMFUnification/api/Admin/Check_AdharSeeding',
    fetchPanInfo = '/KMFUnification/api/Admin/FETCHPANDETAILS',
    // ifscSearch =
    // https://cugapi.kotakmf.com/INVESTOR/api/Admin/IFSCSEARCH
    postLumpsumfirstTimeData = '/KOTAKDISAPI/api/Freshpurchase/DistributorFPTrxDet',
    // Statements
    accountStatement = '/KOTAKDISAPI/api/DistributorAccStmt/GenerateAccstatement',
    capitalGainStatement = '/KOTAKDISAPI/api/CapitalGainStmt/GenerateCapitalGainStmt',
    brokerageReports = '/KMFUnification/api/admin/GETBROKERAGEREPORT',
    getNavData = '/kotakbh/nav/getdata',
    //feedback api
    getAllQueriesForDestributor = '/kotakbh/query/getQuriesByDistributor',
    getAllFeedbackQuery = '/kotakbh/sidebar/getByCategoryId/4',
    getAllFeedbackSubQuery = '/kotakbh/sub-section/getBySidebarId/',
    submitQuery = '/kotakbh/query/api/save',

    //Images
    getCardImages = '/kotakbh/sidebar/getallWishes',
    getWishList = '/PlexNewAPI/api/Values/GetBirthDay_Wish',
    getfestiveList = '/PlexNewAPI/api/one/GetClientCount_Total_CurrentFinYear/',
    getfestiveListNew = '/PlexNewAPI/api/values/GetClientCount_Total_CurrentFinYear/',
    getWisheId = '/kotakbh/wishes/getByCategoryId/',
    sendWishes = '/kotakbh/wishes/send',
    resolveQuery = '/kotakbh/query/status/api/save',

    cirtificate = '/kotakbh/certificate/getall',

    // co-branding
    getAllCoBranding = '/kotakbh/cobranding-content/getContent',
    getAllScheme = '/kotakbh/scheme/getall',
    getAllSchemeByBucketType = '/kotakbh/scheme/getbybucket/',
    getCobrandById = '/kotakbh/cobranding-content/getByIdAuth/', // content id , user id
    // getCobrandById = '/kotakbh/cobranding-content/api/getbyid/', // content id , user id
    generateCobrand = '/kotakbh/cobranding-content/generate/', // content id , user id
    statusCobrand = '/kotakbh/cobranding-content/getstatus/', // content id , user id
    readStatusCobrand = '/kotakbh/cobranding-content/readStatus/', // content id , user id
    viewContentCobrand = '/kotakbh/cobranding-content/getById/', // content id , user id
    downloadCobrand = '/kotakbh/cobranding-content/download/api/save',
    viewCobrandCount = '/kotakbh/cobranding-content/view/api/save',
    shareCobrandCount = '/kotakbh/cobranding-content/share/api/save',
    // error page
    noInternet = '',

    userLogs = '/kotakbh/loginDetails/api/save',
    getFundDetailsFromCode = '/KMFUnification/api/Admin/GETSTPSWPENABLE',
    getOtp = '/KMFUnification/api/admin/GENOTP',
    validateOTPKmfUnification = '/KMFUnification/api/admin/VALOTP',
    finalOtp = '/KMFUnification/api/admin/INSCALLBACKDET',

    // getFundCodeFromAMFI = '/KMFUnification/api/Admin/GETDISTAMFISCHCODE',

    //empanelment
    postEmpanelment = '/KMFUnification/api/Admin/CREATEBROKER',
    getEmpanelmentStatus = '/KMFUnification/api/Admin/BROKEREMPANELSTATUS',
    getEmpDetails = '/KMFUnification/api/Admin/GETBROKERDETAIL',
    postEmpImage = '/KMFUnification/api/Admin/MFDIMGUPD',
    appStateInfo = '/kotakbh/version/getall',
    count = '/kotakbh/pre-login/count/api/getall',
    testimonial = '/kotakbh/testimonial/getData',
    getFundCodeFromAMFI = '/KMFUnification/api/Admin/GETDISTAMFISCHCODE',
    // folio details
    getNomineDetails = '/KMFUnification/api/Admin/GETFOLIOSVALIDATE ',
    getFolioDetails = '/KMFUnification/api/Admin/GETFOLIODETAILS',
    getNomineeDistributor = '/KMFUnification/api/admin/GetNomineeDistributor', //'/cug/api/Admin/GETNomineeDistributorKBH',,
    // Bank Mandate
    listBankMandate = '/KMFUnification/api/Admin/BANKMANDATEDET',

    //PreLogin Trigger Transaction

    preLoginGenerateOtp = '/kotakbh/login/prelogin',
    preLoginValidateOtP = '/kotakbh/login/validateprelogin',

    // create new Otm
    listOTMBAnks = '/KMFUnification/api/Admin/GETPAYOUTBANKNAME',
    getOTMBankData = '/KMFUnification/api/Admin/GETEXBANKDETAILS',
    validateOTMBank = '/KMFUnification/api/Admin/CHKEOTMBANK',

    //Get Nominee Details
    bankMandateActions = '/KMFUnification/api/Admin/DistributorAddMandate', //'/cug/api/Admin/DistributorAddMandateKBH',,

    validateVPA = '/KMFUnification/api/admin/VALIDVPA',
    submitOTM = '/KOTAKDISAPI/api/Zerobalance/DistributorAddOTMDet',
    otmList = '/kotakbh/api/GetOTM/GetOTMDetails',

    //Contact Details
    validateContact = '/KMFUnification/api/Admin/CHANGECONTACT/CHECK/COOLINGPERIOD',
    updateContact = '/KMFUnification/api/Admin/CHANGECONTACT/DISSUBMIT', //KMFUnification/api/Admin/CHANGECONTACT/DISSUBMIT
    getContactMarketValue = '/PlexNewAPI/api/Values/GetClientCount_Total_CurrentFinYear/',

    //ratecard
    ratecard = '/kotakbh/api/ratecard/download',
    rateCarddownloadForPdf = '/kotakbh/api/ratecard/downloadPdf',
    rateCarddownloadForExcel = '/kotakbh/api/ratecard/downloadExcel',

    //UPI iD LIST

    upiIDList = '/INVESTOR/api/admin/GETEXISTVPA',

    // API URLS
    panMobileValidation = '/INVESTOR/api/Admin/panEmailMobileValidate',

    //FATCA API URLS
    submitFatca = '/KMFUnification/api/Admin/FATCA',
    // fetchFatcaOptions = '/KMFUnification/api/Admin/FATCADETAILS',

    cloudErrUrl = '',

    // on SucessDashboarLogin
    dashboardLoginSucccess = '/kotakbh/api/DashboardShown'
}

// get OTP

export const DASHBOARDAPI = [
    { name: 'getAumData', url: '/PlexNewAPI/api/Values/GetAumData', method: 'GET', input: {} },
    { name: 'getLUMPSUM_SchemeWise', url: '/PlexNewAPI/api/Values/GetLUMPSUM_SchemeWise', method: 'GET', input: {} },
    { name: 'getLUMPSUM_TotalInvestments', url: '/PlexNewAPI/api/Values/GetLUMPSUM_TotalInvestments', method: 'GET', input: {} },
    { name: 'getSIP_NOTRENEWED', url: '/PlexNewAPI/api/Values/GetSIP_NOTRENEWED', method: 'GET', input: {} },
    { name: 'getEquityInvestor_SchemeWise', url: '/PlexNewAPI/api/Values/GetEquityInvestor_SchemeWise', method: 'GET', input: {} },
    { name: 'getEquityInvestor_TotalInvestments', url: '/PlexNewAPI/api/Values/GetEquityInvestor_TotalInvestments', method: 'GET', input: {} },
    { name: 'getSipUpcoming_ForMaturity', url: '/PlexNewAPI/api/Values/GetSipUpcoming_ForMaturity', method: 'GET', input: {} },
    { name: 'getTotalClients', url: '/PlexNewAPI/api/Values/GetTotalClients', method: 'GET', input: {} },
    { name: 'getSipData_TillDate', url: '/PlexNewAPI/api/Values/GetSipData_TillDate', method: 'GET', input: {} },
    { name: 'getSip_ForCurrentYear', url: '/PlexNewAPI/api/Values/GetSip_ForCurrentYear', method: 'GET', input: {} },
    { name: 'STP_SWP_Count_Report', url: '/PlexNewAPI/api/one/STP_SWP_Count_Report', method: 'POST', input: {} },
    { name: 'getnextGoalData', url: '/kotakbh/goal/getByArn', method: 'GET', input: {} },
    { name: 'getBannerData', url: '/kotakbh/banner/getall', method: 'GET', input: {} },
    { name: 'getTransactionHistory', url: '/kotakbh/trans/get', method: 'GET', input: {} },
    { name: 'getCirtificateData', url: '/kotakbh/certificate/getall', method: 'GET', input: {} },
    { name: 'getProfileInfo', url: API_URL.getProfileInfo, method: 'GET', input: {} },
    { name: 'getPendingTransaction', url: API_URL.getPendingTransaction, method: 'GET', input: {} },
];

export const ActivationOpportunitiesAPI = [
    { name: 'GetInactiveInvestor_TotalInvestments', url: '/PlexNewAPI/api/Values/GetInactiveInvestor_TotalInvestments', method: 'GET', input: {}, path: 'inactive' },
    { name: 'GetZeroBalanceInvestor', url: '/PlexNewAPI/api/Values/GetZeroBalanceInvestor', method: 'GET', input: {}, path: 'zerobalance' },
    { name: 'GetInactiveInvestor_SchemeWise', url: '/PlexNewAPI/api/Values/GetInactiveInvestor_SchemeWise', method: 'GET', input: {}, path: 'inactive' },
];

export const SIPOpportunitiesAPI = [
    { name: 'GetSIP_CEASED', url: '/PlexNewAPI/api/Values/GetSIP_CEASED', method: 'GET', input: {}, path: 'ceased' },
    { name: 'getSIP_NOTRENEWED', url: '/PlexNewAPI/api/Values/GetSIP_NOTRENEWED', method: 'GET', input: {}, path: 'notrenewed' },
    { name: 'getSipUpcoming_ForMaturity', url: '/PlexNewAPI/api/Values/GetSipUpcoming_ForMaturity', method: 'GET', input: {}, path: 'maturity' },
    { name: 'GetSip_Rejection', url: '/PlexNewAPI/api/Values/GetSip_Rejection', method: 'GET', input: {}, path: 'rejected' },
    { name: 'GetLUMPSUM_TotalInvestments', url: '/PlexNewAPI/api/Values/GetLUMPSUM_TotalInvestments', method: 'GET', input: {}, path: 'lumpsum' },
    { name: 'GetLUMPSUM_SchemeWise', url: '/PlexNewAPI/api/Values/GetLUMPSUM_SchemeWise', method: 'GET', input: {}, path: 'lumpsum' },
];
export const CrossSellOpportunitiesAPI = [
    { name: 'GetLIQUIDInvestor_TotalInvestments', url: '/PlexNewAPI/api/Values/GetLIQUIDInvestor_TotalInvestments', method: 'GET', input: {}, path: 'liquid' },
    { name: 'GetLiquidInvestor_SchemeWise', url: '/PlexNewAPI/api/Values/GetLiquidInvestor_SchemeWise', method: 'GET', input: {}, path: 'liquid' },
    { name: 'GetEquityInvestor_TotalInvestments', url: '/PlexNewAPI/api/Values/GetEquityInvestor_TotalInvestments', method: 'GET', input: {}, path: 'equity' },
    { name: 'GetEquityInvestor_SchemeWise', url: '/PlexNewAPI/api/Values/GetEquityInvestor_SchemeWise', method: 'GET', input: {}, path: 'equity' },
    { name: 'GetDebtInvestor_TotalInvestments', url: '/PlexNewAPI/api/Values/GetDebtInvestor_TotalInvestments', method: 'GET', input: {}, path: 'debt' },
    { name: 'GetDebtInvestor_SchemeWise', url: '/PlexNewAPI/api/Values/GetDebtInvestor_SchemeWise', method: 'GET', input: {}, path: 'debt' },
    { name: 'GetDividentInvestor_TotalInvestments', url: '/PlexNewAPI/api/Values/GetDividentInvestor_TotalInvestments', method: 'GET', input: {}, path: 'dividend' },
    { name: 'GetDividentInvestor_SchemeWise', url: '/PlexNewAPI/api/Values/GetDividentInvestor_SchemeWise', method: 'GET', input: {}, path: 'dividend' },
];

export const OtherOpportunitiesAPI = [
    { name: 'Last_one_month_redemption_report', url: '/PlexNewAPI/api/one/Last_one_month_redemption_report', method: 'POST', input: {}, path: 'redeem' },
    { name: 'STP_Expiry_Report', url: '/PlexNewAPI/api/one/STP_Expiry_Report', method: 'POST', input: {}, path: 'expiredstp' },
    { name: 'SWP_Expiry_Reports', url: '/PlexNewAPI/api/one/SWP_Expiry_Report', method: 'POST', input: {}, path: 'expiredswp' },
    { name: 'GetELSS_Inv_InCurrentFinancialYr', url: '/PlexNewAPI/api/Values/GetELSS_Inv_InCurrentFinancialYr', method: 'GET', input: {}, path: 'elss' },
];


export const OTMAPI = [
    { name: 'CAMSAPI', url: API_URL.camsOTMDetails, method: 'POST', input: {} },
    { name: 'KOTAKAPI', url: API_URL.kotakOTMDetails, method: 'POST', input: {} },
];
